/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './loading-spinner.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/feature-components/loading-spinner/loading-spinner.component';
const styles_LoadingSpinnerComponent:any[] = [i0.styles];
export const RenderType_LoadingSpinnerComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LoadingSpinnerComponent,data:{}});
export function View_LoadingSpinnerComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'div',[['class',
      'spinner-wrap']],[[8,'hidden',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),0,'div',[['class','loading-spinner']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n']))],(null as any),(_ck,_v) => {
    var _co:i2.LoadingSpinnerComponent = _v.component;
    const currVal_0:boolean = !_co.isLoading;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_LoadingSpinnerComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-loading-spinner',
      ([] as any[]),(null as any),(null as any),(null as any),View_LoadingSpinnerComponent_0,
      RenderType_LoadingSpinnerComponent)),i1.ɵdid(1,114688,(null as any),0,i2.LoadingSpinnerComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LoadingSpinnerComponentNgFactory:i1.ComponentFactory<i2.LoadingSpinnerComponent> = i1.ɵccf('app-loading-spinner',
    i2.LoadingSpinnerComponent,View_LoadingSpinnerComponent_Host_0,{isLoading:'loading'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvZmVhdHVyZS1jb21wb25lbnRzL2xvYWRpbmctc3Bpbm5lci9sb2FkaW5nLXNwaW5uZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvZmVhdHVyZS1jb21wb25lbnRzL2xvYWRpbmctc3Bpbm5lci9sb2FkaW5nLXNwaW5uZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vb3B0L2plbmtpbnMvd29ya3NwYWNlL2dpc2VsYV9wb3J0YWwvc3JjL2FwcC9mZWF0dXJlLWNvbXBvbmVudHMvbG9hZGluZy1zcGlubmVyL2xvYWRpbmctc3Bpbm5lci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvZmVhdHVyZS1jb21wb25lbnRzL2xvYWRpbmctc3Bpbm5lci9sb2FkaW5nLXNwaW5uZXIuY29tcG9uZW50LnRzLkxvYWRpbmdTcGlubmVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBbaGlkZGVuXT1cIiFpc0xvYWRpbmdcIiBjbGFzcz1cInNwaW5uZXItd3JhcFwiPlxuXHQ8ZGl2IGNsYXNzPVwibG9hZGluZy1zcGlubmVyXCI+PC9kaXY+XG48L2Rpdj4iLCI8YXBwLWxvYWRpbmctc3Bpbm5lcj48L2FwcC1sb2FkaW5nLXNwaW5uZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxnQkFBZ0QsMkNBQy9DO01BQUE7TUFBQSwwREFBbUM7TUFBQTs7SUFEL0I7SUFBTCxXQUFLLFNBQUw7Ozs7b0JDQUE7TUFBQTt3Q0FBQSxVQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/feature-components/loading-spinner/loading-spinner.component.ngfactory.ts